import React, { useContext } from 'react';

import { StyledEditorBar } from './editor-bar.styles';

import OpenDocButton from './open-doc-button';
import CommentButton from './comment-button';
import SourceButton from './source-button';

import { Context } from '../../store/store';

const EditorBar = ({value}) => {
  const [state, { efedNoAuth }] = useContext(Context);
  return (
    <StyledEditorBar style={{ display: state.isEditorSidebarOpened ? 'block' : 'none' }}>
      <OpenDocButton />
      {state.isEditorNewDocSidebarOpened && value.length > 0 && <SourceButton />}
      {/*<CommentButton />
      <NewDocButton />
      <CommentButton />
      <SourceButton />
      */}
    </StyledEditorBar>
  );
};

export default EditorBar;
